const ErrorInputText = ({ text }) => {
  return (
    <p style={{ textShadow: "1px 1px 5px white" }} className="text-[#7C0004] font-semibold">
      {text}
    </p>
  );
};

export default ErrorInputText;
